
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71798A","fill-rule":"evenodd","d":"M17.548 12.01a1.99 1.99 0 113.98-.02 1.99 1.99 0 01-3.98.02zm-7.533 0a1.98 1.98 0 113.961 0 1.98 1.98 0 01-3.961 0zm-7.543 0a1.99 1.99 0 111.98 1.98 1.98 1.98 0 01-1.98-1.98z","clip-rule":"evenodd"}})])
          )
        }
      }
    